<!--<div class="message-center">-->
<small *ngIf="errorMessage !== 'null'" class="p-error block">{{
  errorMessage
}}</small>
<!--</div>-->

<!--  <span *ngIf="errorMessage !== 'null'" class="error">{{errorMessage}}</span>-->
<!--  <span *ngIf="errorMessage === null && warn"  class="warn">{{warn}}</span>-->
